import { Menu, Affix, Row, Col } from 'antd'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'
import Loader from './Loader'
import { usePageAccess } from '../../hooks/usePageAccess'
import { useMemo } from 'react'
import { PERMISSIONKEYS, ROLEKEYS } from '../../utils/Permissions.const'

const menu = {
  [PERMISSIONKEYS.USERS]: {
    key: '/admin/users',
    label: 'משתמשים',
  },
  [PERMISSIONKEYS.CATEGORIES]: {
    key: '/admin/sport-categories',
    label: 'ענפי ספורט',
  },
  [PERMISSIONKEYS.TEAMS]: {
    key: '/admin/teams',
    label: 'קבוצות',
  },
  [PERMISSIONKEYS.RECORDS]: {
    key: '/admin/records',
    label: 'רשומות',
  },
  [PERMISSIONKEYS.LOGS]: {
    key: '/admin/logs',
    label: 'לוגים',
  },
  ADMIN: {
    key: '/admin/permissions',
    label: 'ניהול הרשאות',
  },
}

function Container({ children }) {
  if (window.innerWidth < 900) {
    return <>{children}</>
  }

  return (
    <Affix>
      <div>{children}</div>
    </Affix>
  )
}

export default function AdminSidebar() {
  const { logOut } = useUser()
  const { data, isLoading } = usePageAccess()
  const location = useLocation()
  const menuPermissions = useMemo(() => {
    if (data?.role === ROLEKEYS.ADMIN) return Object.values(menu)

    const userPermissions = data?.permissions || []
    return userPermissions.map((permission) => menu[permission])
  }, [data])

  const navigate = useNavigate()

  const onClick = ({ key }) => {
    switch (key) {
      case 'logout':
        logOut()
        break
      default:
        navigate(key)
        break
    }
  }

  if (isLoading) return <Loader />

  return (
    <Container>
      <Row justify="center">
        <Col>
          <Link to="/">
            <img src="/images/logo.png" alt="app-logo" style={{ maxWidth: 70, padding: '24px 0' }} />
          </Link>
        </Col>
      </Row>

      <Menu onClick={onClick} selectedKeys={[location.pathname]} items={menuPermissions} />
    </Container>
  )
}
